import { InjectionToken } from '@angular/core';
import { GridType } from '@data-access/grid-views';
import {
  DEFAULT_BASE_GRID_PROPS,
  DEFAULT_CHECKBOX_PROPS,
  DEFAULT_CHECKBOX_COLUMN,
} from '@data-access/shared';
import { GridConfig } from '@wcg/frontend-framework';
import { UploadDocumentGrid } from '../types';
import environment from '@environments/environment';

export const uploadDocumentGridInitialState: UploadDocumentGrid = {
  data: [],
  gridType: 'submissionUploadDocuments' as GridType,
  views: [],
  ...DEFAULT_CHECKBOX_PROPS,
  ...DEFAULT_BASE_GRID_PROPS,
};

export const UPLOAD_DOCUMENT_GRID_STATE =
  new InjectionToken<UploadDocumentGrid>('Upload document grid state', {
    factory: () => ({ ...uploadDocumentGridInitialState }),
  });

export const UPLOAD_DOCUMENT_GRID_CONFIG: GridConfig = {
  features: {
    gridType: 'submissionUploadDocuments',
    canExportAll: false,
    deleteAll: true,
    canDownloadAll: false,
    paginationOptions: new Set([10, 25, 50, 100]),
  },
  columns: {
    checkbox: DEFAULT_CHECKBOX_COLUMN,
    name: {
      label: 'File Name',
      key: 'name',
      propKey: 'file.name',
      ordinal: 1,
      hyperlink: '',
      sticky: false,
      stickyEnd: false,
      minWidth: 308,
      maxWidth: 350,
      sortable: false,
      sorted: null,
      componentType: 'action',
    },
    taskType: {
      label: environment.enabledTask ? 'Task' : 'Document Name',
      key: 'taskType',
      propKey: 'file.taskType',
      ordinal: 1,
      hyperlink: '',
      sticky: false,
      stickyEnd: false,
      minWidth: 308,
      maxWidth: 350,
      sortable: false,
      sorted: null,
      componentType: 'select',
    },
    documentType: {
      label: 'Document Type',
      key: 'documentType',
      propKey: 'file.documentType',
      ordinal: 1,
      hyperlink: '',
      sticky: false,
      stickyEnd: false,
      minWidth: 308,
      maxWidth: 350,
      sortable: false,
      sorted: null,
      componentType: 'select',
    },
  },
  advancedFilters: {},
};
export const UPLOAD_DOCUMENT_GRID_SEARCH_FIELDS = [
  'file.name',
  'document_type_name',
];
